import { TranslationKeys } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type StepPageHintProps = {
  title: TranslationKeys;
  description: TranslationKeys;
  classNames?: {
    wrapper?: string;
  };
};

export const StepPageHint: FC<StepPageHintProps> = ({ title, description, classNames }) => {
  const { t } = useTranslation();

  return (
    <div className={twMerge('max-w-[280px]', classNames?.wrapper)}>
      <h3 className='text-sm font-semibold text-secondary-700'>{t(title as any)}</h3>
      <p className='text-sm font-normal text-tertiary-600'>{t(description as any)}</p>
    </div>
  );
};
